
const IMAGE_BASE_URL = 'https://resources.groww.in/web-assets/img/onboarding/v2_onboarding/';

export const ONBOARDING_IMAGES = {
  PATTERN_BG: 'pattern-bg',
  GROWW_LOGO: 'groww-logo',
  NOF_LOGO: 'nof-logo',
  ESIGN_IMAGE: 'esign-image',
  FNO_REQUESTED: 'fno-requested',
  PAN_NUMBER: 'pan-number',
  PAN_NAME: 'pan-name',
  MAINTENANCE: 'maintenance',
  TERMINAL_BANNER: 'terminal-banner',
  AADHAAR_HEADER: 'aadhaar-header',
  BANK_FALLBACK: 'bank-fallback',
  EMBLEM_OF_INDIA: 'emblem-of-india',
  SPOT_HERO: 'spot-hero',
  SELFIE_UPLOAD: 'selfie-upload',
  SUCCESS_IMAGE: 'success-image',
  FAILED_IMAGE: 'failed-image',
  GOLD_BAR: 'gold-bar',
  APP_QR_CODE: 'app-qr-code',
  GROWW_SIDE: 'groww-side',
  DOWNLOAD_APP_MSITE: 'download-app-msite',
} as const;


export const ASSETS = {
  [ONBOARDING_IMAGES.PATTERN_BG]: {
    LIGHT: IMAGE_BASE_URL + 'pattern-bg.svg',
    DARK: IMAGE_BASE_URL + 'pattern-bg.svg',
  },
  [ONBOARDING_IMAGES.GROWW_LOGO]: {
    LIGHT: 'https://resources.groww.in/web-assets/img/website-logo/groww_logo.webp',
    DARK: 'https://resources.groww.in/web-assets/img/website-logo/groww-logo-dark-logged-out.webp',
  },
  [ONBOARDING_IMAGES.NOF_LOGO]: {
    LIGHT: IMAGE_BASE_URL + '915-black-transparent.svg',
    DARK: IMAGE_BASE_URL + '915-black-transparent.svg',
  },
  [ONBOARDING_IMAGES.ESIGN_IMAGE]: {
    LIGHT: IMAGE_BASE_URL + 'onbEsign.webp',
    DARK: IMAGE_BASE_URL + 'onbEsignDark.webp',
  },
  [ONBOARDING_IMAGES.FNO_REQUESTED]: {
    LIGHT: IMAGE_BASE_URL + 'fno-requested.svg',
    DARK: IMAGE_BASE_URL + 'fno-requested.svg',
  },
  [ONBOARDING_IMAGES.PAN_NUMBER]: {
    LIGHT: IMAGE_BASE_URL + 'pan_number.webp',
    DARK: IMAGE_BASE_URL + 'pan_number.webp',
  },
  [ONBOARDING_IMAGES.PAN_NAME]: {
    LIGHT: IMAGE_BASE_URL + 'pan_name.webp',
    DARK: IMAGE_BASE_URL + 'pan_name.webp',
  },
  [ONBOARDING_IMAGES.MAINTENANCE]: {
    LIGHT: IMAGE_BASE_URL + 'maintenance_light.webp',
    DARK: IMAGE_BASE_URL + 'maintenance_light.webp',
  },
  [ONBOARDING_IMAGES.TERMINAL_BANNER]: {
    LIGHT: IMAGE_BASE_URL + 'terminal_banner_light.webp',
    DARK: IMAGE_BASE_URL + 'terminal_banner_dark.webp',
  },
  [ONBOARDING_IMAGES.AADHAAR_HEADER]: {
    LIGHT: IMAGE_BASE_URL + 'aadhaar_header.jpg',
    DARK: IMAGE_BASE_URL + 'aadhaar_header.jpg',
  },
  [ONBOARDING_IMAGES.BANK_FALLBACK]: {
    LIGHT: IMAGE_BASE_URL + 'bankFallbackDark.svg',
    DARK: IMAGE_BASE_URL + 'bankFallbackDark.svg',
  },
  [ONBOARDING_IMAGES.EMBLEM_OF_INDIA]: {
    LIGHT: IMAGE_BASE_URL + 'emblemOfIndia.svg',
    DARK: IMAGE_BASE_URL + 'emblemOfIndia.svg',
  },
  [ONBOARDING_IMAGES.SPOT_HERO]: {
    LIGHT: IMAGE_BASE_URL + 'spotHeroAutopay.svg',
    DARK: IMAGE_BASE_URL + 'darkModeIllustration.svg',
  },
  [ONBOARDING_IMAGES.SELFIE_UPLOAD]: {
    LIGHT: 'https://resources.groww.in/web-assets/media-library/2025/12/selfie_upload_light.webp',
    DARK: 'https://resources.groww.in/web-assets/media-library/2025/12/selfie_upload_dark.webp',
  },
  [ONBOARDING_IMAGES.SUCCESS_IMAGE]: {
    LIGHT: IMAGE_BASE_URL + 'successImage.svg',
    DARK: IMAGE_BASE_URL + 'successImage.svg',
  },
  [ONBOARDING_IMAGES.FAILED_IMAGE]: {
    LIGHT: IMAGE_BASE_URL + 'onbFailedState.svg',
    DARK: IMAGE_BASE_URL + 'onbFailedState.svg',
  },
  [ONBOARDING_IMAGES.GOLD_BAR]: {
    LIGHT: 'https://resources.groww.in/mf-assets/web/collection/light/gold_funds.svg',
    DARK: 'https://resources.groww.in/mf-assets/web/collection/dark/gold_funds.svg',
  },
  [ONBOARDING_IMAGES.APP_QR_CODE]: {
    LIGHT: IMAGE_BASE_URL + 'appDownloadQr.png',
    DARK: IMAGE_BASE_URL + 'appDownloadQr.png',
  },
  [ONBOARDING_IMAGES.GROWW_SIDE]: {
    LIGHT: IMAGE_BASE_URL + 'growwDesktopAndAppLight.png',
    DARK: IMAGE_BASE_URL + 'growwDesktopAndAppDark.png',
  },
  [ONBOARDING_IMAGES.DOWNLOAD_APP_MSITE]: {
    LIGHT: IMAGE_BASE_URL + 'downloadApp.svg',
    DARK: IMAGE_BASE_URL + 'downloadApp.svg',
  },
};
